export default function SnakeArenaIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true" fill="none">
      <rect x="2" y="2" width="60" height="60" rx="14" fill="#1D3B24" />
      <circle cx="14" cy="14" r="3" fill="#FFE14D" />
      <circle cx="50" cy="52" r="3.5" fill="#5CE07A" />
      <circle cx="52" cy="14" r="2.5" fill="#FF6BD6" />
      <circle cx="10" cy="48" r="2.5" fill="#3DD6FF" />
      <path d="M12 40c6-12 16 4 24-6s4-18 14-18" stroke="#5B1730" strokeWidth="15" strokeLinecap="round" />
      <path d="M12 40c6-12 16 4 24-6s4-18 14-18" stroke="#FF5D73" strokeWidth="11" strokeLinecap="round" />
      <path d="M12 40c6-12 16 4 24-6s4-18 14-18" stroke="#FFB3BE" strokeWidth="5" strokeLinecap="round" strokeDasharray="0.1 9" />
      <circle cx="50" cy="16" r="8" fill="#FF8A9A" />
      <path d="M56 10l4-3M56 10l4 0" stroke="#FF4D6D" strokeWidth="1.5" strokeLinecap="round" />
      <circle cx="47" cy="12.5" r="2.4" fill="#FFFBE6" />
      <circle cx="53.5" cy="15" r="2.4" fill="#FFFBE6" />
      <circle cx="48" cy="12" r="1.2" fill="#16121F" />
      <circle cx="54.5" cy="14.5" r="1.2" fill="#16121F" />
    </svg>
  );
}
